export default "__VITE_ASSET__LbAYbRch__"